export const maps =
[
  {
    name: 'OSM Albania.exe',
    url: 'http://osmap.org/maps/OSM Albania.exe',
    type: 'Windows',
    size: 102.56,
    date: 'Thu Aug 01 2019 06:09:52 GMT+0300 (Eastern European Summer Time)'
  },
  {
    name: 'OSM Argentina.exe',
    url: 'http://osmap.org/maps/OSM Argentina.exe',
    type: 'Windows',
    size: 228.16,
    date: 'Mon Nov 08 2021 10:15:54 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM BiH.exe',
    url: 'http://osmap.org/maps/OSM BiH.exe',
    type: 'Windows',
    size: 239.36,
    date: 'Thu Feb 06 2020 00:21:30 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM Bulgaria.exe',
    url: 'http://osmap.org/maps/OSM Bulgaria.exe',
    type: 'Windows',
    size: 355.35,
    date: 'Wed Jan 13 2021 19:51:48 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM Chile.exe',
    url: 'http://osmap.org/maps/OSM Chile.exe',
    type: 'Windows',
    size: 236.31,
    date: 'Fri Nov 12 2021 14:28:41 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM Croatia.exe',
    url: 'http://osmap.org/maps/OSM Croatia.exe',
    type: 'Windows',
    size: 262.65,
    date: 'Wed Feb 05 2020 00:13:28 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM Georgia.exe',
    url: 'http://osmap.org/maps/OSM Georgia.exe',
    type: 'Windows',
    size: 61.53,
    date: 'Wed May 25 2022 19:14:55 GMT+0300 (Eastern European Summer Time)'
  },
  {
    name: 'OSM Greece.exe',
    url: 'http://osmap.org/maps/OSM Greece.exe',
    type: 'Windows',
    size: 609.43,
    date: 'Tue Sep 26 2023 05:03:12 GMT+0300 (Eastern European Summer Time)'
  },
  {
    name: 'OSM Italy.exe',
    url: 'http://osmap.org/maps/OSM Italy.exe',
    type: 'Windows',
    size: 1656.62,
    date: 'Sun Jul 02 2017 23:47:02 GMT+0300 (Eastern European Summer Time)'
  },
  {
    name: 'OSM Kosovo.exe',
    url: 'http://osmap.org/maps/OSM Kosovo.exe',
    type: 'Windows',
    size: 66.88,
    date: 'Sun Feb 09 2020 00:05:18 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM Macedonia.exe',
    url: 'http://osmap.org/maps/OSM Macedonia.exe',
    type: 'Windows',
    size: 92.5,
    date: 'Fri Feb 07 2020 01:08:58 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM Montenegro.exe',
    url: 'http://osmap.org/maps/OSM Montenegro.exe',
    type: 'Windows',
    size: 84.44,
    date: 'Mon Feb 10 2020 00:14:28 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM Road.exe',
    url: 'http://osmap.org/maps/OSM Road.exe',
    type: 'Windows',
    size: 297.29,
    date: 'Thu Feb 27 2020 06:14:14 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM Romania.exe',
    url: 'http://osmap.org/maps/OSM Romania.exe',
    type: 'Windows',
    size: 836.81,
    date: 'Mon Feb 03 2020 01:32:39 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM Scotland.exe',
    url: 'http://osmap.org/maps/OSM Scotland.exe',
    type: 'Windows',
    size: 325.45,
    date: 'Wed Apr 19 2017 17:10:43 GMT+0300 (Eastern European Summer Time)'
  },
  {
    name: 'OSM Serbia.exe',
    url: 'http://osmap.org/maps/OSM Serbia.exe',
    type: 'Windows',
    size: 346.48,
    date: 'Sat Feb 08 2020 01:18:52 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM Slovakia.exe',
    url: 'http://osmap.org/maps/OSM Slovakia.exe',
    type: 'Windows',
    size: 311.05,
    date: 'Tue Feb 11 2020 06:17:28 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSM Slovenia.exe',
    url: 'http://osmap.org/maps/OSM Slovenia.exe',
    type: 'Windows',
    size: 261.19,
    date: 'Tue Feb 04 2020 03:18:00 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMAlbania.img',
    url: 'http://osmap.org/maps/OSMAlbania.img',
    type: 'Garmin',
    size: 111.98,
    date: 'Thu Aug 01 2019 06:09:53 GMT+0300 (Eastern European Summer Time)'
  },
  {
    name: 'OSMArgentina.img',
    url: 'http://osmap.org/maps/OSMArgentina.img',
    type: 'Garmin',
    size: 293.65,
    date: 'Mon Nov 08 2021 10:15:56 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMBiH.img',
    url: 'http://osmap.org/maps/OSMBiH.img',
    type: 'Garmin',
    size: 261.98,
    date: 'Thu Feb 06 2020 00:21:33 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMBulgaria.img',
    url: 'http://osmap.org/maps/OSMBulgaria.img',
    type: 'Garmin',
    size: 402.02,
    date: 'Wed Jan 13 2021 19:51:51 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMChile.img',
    url: 'http://osmap.org/maps/OSMChile.img',
    type: 'Garmin',
    size: 303.98,
    date: 'Fri Nov 12 2021 14:28:41 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMCroatia.img',
    url: 'http://osmap.org/maps/OSMCroatia.img',
    type: 'Garmin',
    size: 305.36,
    date: 'Wed Feb 05 2020 00:13:30 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMGeorgia.img',
    url: 'http://osmap.org/maps/OSMGeorgia.img',
    type: 'Garmin',
    size: 79.96,
    date: 'Wed May 25 2022 19:14:55 GMT+0300 (Eastern European Summer Time)'
  },
  {
    name: 'OSMGreece.img',
    url: 'http://osmap.org/maps/OSMGreece.img',
    type: 'Garmin',
    size: 709.2,
    date: 'Tue Sep 26 2023 05:03:20 GMT+0300 (Eastern European Summer Time)'
  },
  {
    name: 'OSMItaly.img',
    url: 'http://osmap.org/maps/OSMItaly.img',
    type: 'Garmin',
    size: 2238.19,
    date: 'Mon Feb 03 2020 00:44:37 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMKosovo.img',
    url: 'http://osmap.org/maps/OSMKosovo.img',
    type: 'Garmin',
    size: 74.46,
    date: 'Sun Feb 09 2020 00:05:18 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMMacedonia.img',
    url: 'http://osmap.org/maps/OSMMacedonia.img',
    type: 'Garmin',
    size: 99.71,
    date: 'Fri Feb 07 2020 01:08:58 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMMontenegro.img',
    url: 'http://osmap.org/maps/OSMMontenegro.img',
    type: 'Garmin',
    size: 90.56,
    date: 'Mon Feb 10 2020 00:14:29 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMRoad.img',
    url: 'http://osmap.org/maps/OSMRoad.img',
    type: 'Garmin',
    size: 385.78,
    date: 'Thu Feb 27 2020 06:14:16 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMRomania.img',
    url: 'http://osmap.org/maps/OSMRomania.img',
    type: 'Garmin',
    size: 936.44,
    date: 'Mon Feb 03 2020 01:32:45 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMScotland.img',
    url: 'http://osmap.org/maps/OSMScotland.img',
    type: 'Garmin',
    size: 374.3,
    date: 'Wed Apr 19 2017 17:10:43 GMT+0300 (Eastern European Summer Time)'
  },
  {
    name: 'OSMSerbia.img',
    url: 'http://osmap.org/maps/OSMSerbia.img',
    type: 'Garmin',
    size: 384.88,
    date: 'Sat Feb 08 2020 01:18:56 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMSlovakia.img',
    url: 'http://osmap.org/maps/OSMSlovakia.img',
    type: 'Garmin',
    size: 375.42,
    date: 'Tue Feb 11 2020 06:17:31 GMT+0200 (Eastern European Standard Time)'
  },
  {
    name: 'OSMSlovenia.img',
    url: 'http://osmap.org/maps/OSMSlovenia.img',
    type: 'Garmin',
    size: 301.8,
    date: 'Tue Feb 04 2020 03:18:02 GMT+0200 (Eastern European Standard Time)'
  }
]
